export var showBalanceServiceCheckVisibleSelector = function (wallet) { return function (state) {
    return state.content.includes(wallet);
}; };
export var showBalanceServiceLoadingSelector = function (state) { return Boolean(state.loading); };
export var showBalanceServiceInitializedSelector = function (state) { return Boolean(state.initialized); };
